var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcompanharObraSensiaBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 46.6666V9.33329C7 6.76662 9.07898 4.66663 11.6719 4.66663H44.3749C46.9444 4.66663 49 6.76662 49 9.33329V46.6666C49 49.2333 46.9444 51.3333 44.3749 51.3333H35.0078V46.6666H42.0649C43.3535 46.6666 44.3982 45.622 44.3982 44.3333V11.6666C44.3982 10.378 43.3535 9.33329 42.0649 9.33329H13.9585C12.6698 9.33329 11.6251 10.378 11.6251 11.6666V44.3333C11.6251 45.622 12.6698 46.6666 13.9585 46.6666H20.9922V51.3333H11.6719C9.10234 51.3333 7 49.2333 7 46.6666Z",
    fill: "#86AA63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 35C22.0447 35 21 36.0446 21 37.3333V51.3333H35V37.3333C35 36.0446 33.9553 35 32.6667 35H23.3333Z",
    fill: "#86AA63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 14H23.3333V18.6666H18.6667V14Z",
    fill: "#86AA63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 14H32.6667V18.6666H37.3333V14Z",
    fill: "#86AA63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 25.6666H23.3333V30.3333H18.6667V25.6666Z",
    fill: "#86AA63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 25.6666H32.6667V30.3333H37.3333V25.6666Z",
    fill: "#86AA63"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcompanharObraSensiaBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/acompanhar_obra_sensia_big.b6ca72f076c94ed6fb553831cb320336.svg";